<template>
  <el-card class="card" v-loading="!rendered">
    <p class="title">{{ $t('data.perform.uploadingOverview') }}</p>
    <el-select
      class="select"
      v-model="cycle"
      placeholder="请选择周期"
      @change="fetchData"
    >
      <el-option
        v-for="[id] of cycleMap"
        :key="id"
        :label="$t(`data.perform.cycleMap[${id}]`)"
        :value="id"
      >
      </el-option>
    </el-select>
    <div class="chart" ref="upload-data" />
  </el-card>
</template>

<script>
import { Chart, DataView } from '@/utils/g2'
import { cycleMap } from '../../mixin'
import dataService from '@/api/data'
import dayjs from 'dayjs'
import { formatAxis } from '@/utils/strUtil'

export default {
  name: 'UploadDataChart',

  data() {
    return {
      rendered: false,
      cycleMap,
      cycle: -7,
      chart: null,
      data: []
    }
  },

  computed: {
    uploadDataEl() {
      return this.$refs['upload-data']
    }
  },

  async mounted() {
    await this.fetchData()
  },

  beforeDestroy() {
    this.chart && this.chart.destroy()
  },

  methods: {
    async fetchData() {
      try {
        const { list } = await dataService.queryUploadInfo({ cycle: this.cycle })
        this.data = list
        if (this.rendered) {
          const dv = this.dataInit()
          this.chart.changeData(dv)
        } else {
          this.renderUploadDataChart()
        }
      } catch (err) {
        this.$message.error('获取上传作品情况失败')
      }
    },
    dataInit(chart) {
      const dv = new DataView().source(this.data)

      dv.transform({
        type: 'rename',
        map: {
          trackTotal: this.$t('data.perform.track'),
          albumTotal: this.$t('data.perform.album'),
          singerTotal: this.$t('data.perform.mv'),
          mvTotal: this.$t('data.perform.singer')
        }
      })

      dv.transform({
        type: 'fold',
        fields: [
          this.$t('data.perform.track'),
          this.$t('data.perform.album'),
          this.$t('data.perform.mv'),
          this.$t('data.perform.singer')],
        key: 'type',
        value: 'count'
      })

      dv.transform({
        type: 'map',
        callback: (row) => {
          row.impDate = dayjs(String(row.impDate)).format('YYYY-MM-DD')
          return row
        }
      })

      return dv.rows
    },

    renderUploadDataChart() {
      this.chart = new Chart({
        container: this.uploadDataEl,
        autoFit: true,
        height: 262,
        width: 470,
        padding: [50, 40, 30, 60]
      })

      const dv = this.dataInit()
      this.chart.data(dv)

      this.chart.legend('type', {
        position: 'top-left',
        offsetY: 5,
        itemSpacing: 15
      })

      this.chart.scale('impDate', {
        type: 'time',
        tickCount: 5,
      })

      this.chart.axis('count', {
        label: {
          formatter: formatAxis
        }
      })

      this.chart.tooltip({
        shared: true,
        showCrosshairs: true,
      })

      this.chart
        .line()
        .position('impDate*count')
        .color('type', ['#577CFB', '#3BD9C5', '#F3C850', '#0B4177'])

      this.chart.render()
      this.rendered = true
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  height: 324px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  color: #002444;
}

.select {
  z-index: 1;
  position: absolute;
  width: 100px;
  top: 50px;
  right: 20px;
}
</style>
